import React from "react";
import { Col, Row, Form, Input } from "antd";

const { Item } = Form;

const Email = () => {
  return (
    <Row span={24}>
      <Col xs={24} md={12}>
        <Row xs={24} md={12}>
          <Col xs={8} md={8}>
            <h4>Email</h4>
          </Col>
          <Col xs={16} md={15}>
            <Item
              name="email"
              rules={[
                {
                  type: "email",
                  message: "Please Enter correct Email!",
                },
              ]}
            >
              <Input
                size="large"
                name="email"
                style={{ borderRadius: 8 }}
                placeholder="Your Email Id"
              />
            </Item>
          </Col>
        </Row>
      </Col>
      <Col xs={24} md={12}>
        <Row justify="space-between">
          <Col xs={8} md={8}>
            <h4>Email 2</h4>
          </Col>
          <Col xs={16} md={15}>
            <Item
              name="email2"
              rules={[
                {
                  type: "email",
                  message: "Please Enter correct Email!",
                },
              ]}
            >
              <Input
                size="large"
                name="email2"
                style={{ borderRadius: 8 }}
                placeholder="Your Email Id "
              />
            </Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Email;
